import * as React from 'react';

import {OnboardingBody} from 'shells/onboarding-page/onboarding-body';

export function HelpBodyTasks() {
    return (
        <OnboardingBody title='What are tasks?'>
            <div>
                <p>
                    You can define tasks that must be completed during each stage for every lead.
                    Nutshell will automatically add these at the right stage.
                </p>
                <p>
                    Tasks might include prompts to make a call, prepare for a meeting, or other work
                    that should be repeated for every lead.
                </p>
            </div>
        </OnboardingBody>
    );
}
